<app-header></app-header>
<app-side-menu [menu]="menu" [vendorMenu]="vendorMenu"></app-side-menu>
<router-outlet />
<app-error-list></app-error-list>
